/* STRYXX — product card hover preview
   - Desktop crossfade to 2nd image is pure CSS (.card-gallery:hover .stryxx-hover).
   - This script adds: optional hover cycle through images, and mobile tap-to-preview.
   No external dependencies. */
(function () {
  var canHover = window.matchMedia('(hover: hover)').matches;

  function initCycle(root) {
    if (!canHover) return;
    (root || document).querySelectorAll('.stryxx-hover[data-cycle="true"]').forEach(function (hover) {
      var gallery = hover.closest('.card-gallery');
      if (!gallery || gallery.dataset.stryxxCycleBound) return;
      var imgs = hover.querySelectorAll('.stryxx-hover__img');
      if (imgs.length < 2) return;
      gallery.dataset.stryxxCycleBound = '1';
      var timer = null, i = 0;
      gallery.addEventListener('mouseenter', function () {
        i = 0;
        timer = window.setInterval(function () {
          imgs[i].style.opacity = '0';
          i = (i + 1) % imgs.length;
          imgs[i].style.opacity = '1';
        }, 850);
      });
      gallery.addEventListener('mouseleave', function () {
        if (timer) { clearInterval(timer); timer = null; }
        imgs.forEach(function (im, idx) { im.style.opacity = idx === 0 ? '1' : '0'; });
        i = 0;
      });
    });
  }

  // Mobile: first tap on a card previews the 2nd image, second tap opens the product.
  if (!canHover) {
    document.addEventListener('click', function (e) {
      var gallery = e.target.closest && e.target.closest('.card-gallery');
      if (!gallery) return;
      var hover = gallery.querySelector('.stryxx-hover');
      if (!hover || hover.dataset.mobile !== 'tap') return;
      if (!gallery.classList.contains('stryxx-show-hover')) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.card-gallery.stryxx-show-hover').forEach(function (o) {
          if (o !== gallery) o.classList.remove('stryxx-show-hover');
        });
        gallery.classList.add('stryxx-show-hover');
      }
      // second tap: do nothing here, let the link navigate
    }, true);
  }

  if (document.readyState !== 'loading') initCycle();
  else document.addEventListener('DOMContentLoaded', function () { initCycle(); });
  // Re-bind in the theme editor when sections re-render
  document.addEventListener('shopify:section:load', function (e) { initCycle(e.target); });
})();
